import {
  AppRuntimeConfiguration,
  computeItemIdentifier,
} from '@o3r/core';
import {
  COMPONENTS_CONFIGURATION_NAME,
} from '../../configuration';

/**
 * MetaConnect configuration
 *
 * @title MetaConnect
 */
export interface MetaConnectConfig extends AppRuntimeConfiguration {
  /**
   * Enable Meta Connect injection service into the prime booking flow
   *
   * @o3rCategory technical
   * @label Enable Meta Connect
   */
  enableMetaConnect: boolean;

  /**
   * Airline's IATA code (2 characters) used for Meta Connect script
   *
   * @o3rCategory technical
   * @label Airline code
   */
  airlineCode: string;
}

export const META_CONNECT_DEFAULT_CONFIG: MetaConnectConfig = {
  enableMetaConnect: false,
  airlineCode: ''
};

export const META_CONNECT_CONFIG_ID = computeItemIdentifier('MetaConnectConfig', COMPONENTS_CONFIGURATION_NAME);
